import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { InactivityService, InactivityState } from 'src/app/core/services/inactivity.service';

@Component({
    selector: 'app-inactivity-timer',
    templateUrl: './inactivity-timer.component.html',
    styleUrls: ['./inactivity-timer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [TranslateModule]
})
export class InactivityTimerComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<void>();

  inactivityState: InactivityState = {
    isWarningVisible: false,
    secondsRemaining: 0,
    isActive: false
  };

  constructor(
    private readonly _inactivityService: InactivityService,
    private readonly cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    // Subscribe to inactivity state changes
    this._inactivityService.getState()
      .pipe(takeUntil(this.destroy$))
      .subscribe(state => {
        this.inactivityState = state;
        this.cdr.detectChanges();
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }


  /**
   * Format remaining time as MM:SS
   */
  getFormattedTime(): string {
    const seconds = this.inactivityState.secondsRemaining;
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;

    return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  }

  /**
   * Get the appropriate CSS class based on remaining time
   */
  getTimerClass(): string {
    const seconds = this.inactivityState.secondsRemaining;
    if (seconds <= 10) return 'timer-critical';
    if (seconds <= 30) return 'timer-warning';
    return 'timer-normal';
  }

  /**
   * Get progress bar width percentage
   */
  getProgressWidth(): number {
    const totalWarningTime = 60; // 60 seconds warning period
    const remaining = this.inactivityState.secondsRemaining;
    return Math.max(0, (remaining / totalWarningTime) * 100);
  }
}
